import { AgResourceLanguage } from '../types';
import { sharedComponents as EnUsSharedComponents } from '../en-us/sharedComponents';

export const sharedComponents: AgResourceLanguage['sharedComponents'] = {
  ...EnUsSharedComponents,
  outOfStock: 'Niet op Voorraad',
  comingSoon: 'Binnenkort Beschikbaar',
  button: {
    cancel: 'Annuleren',
    delete: 'Verwijderen',
    remove: 'Verwijderen'
  },
  supportCard: {
    title: 'Hulp nodig met je bestelling?',
    description: 'Voor meer informatie',
    linkFAQ: 'bezoek de FAQ-pagina',
    email: 'support@athleticgreens.com',
    phone: '1-888-390-4029',
    phoneHref: '+18883904029'
  },
  paymentInfoBackGuarantee: {
    label: '90-Dagen Niet Goed, Geld Terug Garantie',
    description: 'Als je niet van je AG1 houdt binnen de eerste 90 dagen, is het op ons.'
  },
  paymentInfoCancelAnytime: {
    label: 'Pauzeer, Wijzig of Annuleer Altijd',
    description: 'Pas je abonnement aan als je behoeften veranderen. Jij hebt de controle.'
  },
  promoCode: {
    promoButtonLabel: 'Toepassen',
    promoCTA: 'Heb je een promotiecode?',
    promoError: 'Kortingscode is ongeldig',
    promoInputLabel: 'Promotiecode'
  },
  summaryCheckout: {
    freePrice: 'Gratis',
    discountLabel: 'Je korting',
    totalLabel: 'Totaal',
    taxLabel: 'Belasting',
    taxNotReady: '---',
    shippingLabel: 'Verzending',
    subtotalLabel: 'Subtotaal',
    taxEstimatedLabel: 'Geschatte Belasting',
    shippingExpectedPrice: 'Gratis'
  },
  addressForm: {
    firstName: 'Voornaam*',
    lastName: 'Achternaam*',
    country: 'Land/regio*',
    addressLine1: 'Adres',
    addressLine2: 'Appartement, Suite, Etc',
    city: 'Stad',
    province: 'Provincie',
    zipCode: 'Postcode',
    phone: 'Telefoon',
    company: 'Bedrijf',
    optional: 'optioneel'
  },
  // MODAL CONTENT
  editShippingAddress: {
    headerEdit: 'Verzendadres Bewerken',
    headerCreate: 'Verzendadres Aanmaken',
    headerSelect: 'Selecteer Verzendadres',
    reloadMessage: 'Herlaad de pagina, alstublieft',
    titleEditAddress: 'Adresinformatie',
    usedSavedLabel: 'Gebruik opgeslagen adres',
    useSavedAddressText: 'Kies het bezorgadres voor je bestelling.',
    noSavedAddressText: 'Je hebt momenteel geen opgeslagen adressen',
    useSavedAddressButton: 'Gebruik opgeslagen adres',
    noSavedAddressButton: 'Geen opgeslagen adressen',
    defaultAddress: 'Standaardadres:',
    defaultAddressText: 'Dit adres wordt gebruikt voor je abonnement.',
    otherAddresses: 'Aanvullende Adressen',
    cancelEditButton: 'Annuleren',
    updateEditButton: 'Bijwerken',
    saveButton: 'Opslaan',
    cancelSelectButton: 'Annuleren',
    updateSelectButton: 'Gebruik geselecteerd',
    submitSelectButton: 'Ok',
    massUpdate: 'Gebruik voor alle actieve abonnementen',
    subscriptionUpdate: 'Instellen als verzendadres voor mijn abonnement',
    giftTitle: 'Versturen als cadeau',
    giftRecipientEmailLabel: 'E-mail Ontvanger*',
    giftMessageLabel: 'Cadeaubericht',
    giftAddressClosingAlert: {
      title: 'Ontvangstadres Cadeau Sluiten',
      content:
        'Weet je zeker dat je het bezorgadres wilt sluiten zonder bij te werken? Je cadeau wordt verzonden naar je standaardadres',
      editAddressButton: 'Adres bewerken',
      confirmButton: 'Bevestigen'
    }
  },
  acceptDeleteAddress: {
    titleHeader: 'Adres Verwijderen',
    description: 'Weet je zeker dat je het opgeslagen adres wilt verwijderen?',
    cancelButton: 'Annuleren',
    deleteButton: 'Verwijderen'
  },
  addressVerified: {
    title: 'Bevestig Je Adres',
    text: 'We konden het exacte adres dat je hebt ingevoerd niet verifiëren. Controleer of het correct is of breng indien nodig wijzigingen aan.',
    suggested: 'Voorgesteld Adres',
    entered: 'Ingevoerd Adres',
    edit: 'Adres Bewerken',
    continue: 'Opslaan & Doorgaan'
  },
  giftLabel: {
    short: 'Cadeau',
    long: 'Je Cadeau'
  },
  v53: {
    originalFlavorTitle: 'Origineel',
    upgradedFormulaText: 'VERBETERDE FORMULE',
    selectFlavorText: 'Selecteer Smaak',
    discardChanges: {
      title: 'Unsaved Changes',
      text: 'Do want to save the changes you made to your subscription?',
      save: 'Save Changes',
      discard: 'Discard Changes'
    }
  }
};
